import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const trackingEventType = PropTypes.shape({
    category: PropTypes.string,
    action: PropTypes.string,
    label: PropTypes.string,
    count: PropTypes.number,
});

const propTypes = {
    item: trackingEventType,
    className: PropTypes.string,
};

const defaultProps = {
    item: null,
    className: null,
};

const TrackingEventItem = ({ item, className }) => {
    const { action = null, label = null, count = null } = item || {};

    return (
        <tr
            className={classNames([
                {
                    [className]: className !== null,
                },
                'font-weight-normal',
            ])}
        >
            <td>{action}</td>
            <td>{label}</td>
            <td>{count}</td>
        </tr>
    );
};

TrackingEventItem.propTypes = propTypes;
TrackingEventItem.defaultProps = defaultProps;

export default TrackingEventItem;
